/* eslint-disable import/prefer-default-export */
export const DEFAULT_SELECTED_COMPETITON = 'All Competitions';
